import { generator } from '@cms-max/cms-browser-api-client'
import { Activity, Component } from '@cms-max/medicare-api-sdk'
import { GeneratorArgs } from './generateEventMap'

export const claimsEventGenerator = generator(({ i18n }: GeneratorArgs) => {
  const ns = 'claims'
  return ({
    // Claims Order MSN Link Click
    claims_openorderMSN_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.Claims,
        elementId: 'claims_openorderMSN_click',
        coreClickData: {
          linkText: i18n.t('information.orderMSNLink', { ns })
        }
      }
    },
    // Claims Duplicate MSN Cancel Click
    claims_duplicatemsncancel_button: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.Claims,
        elementId: 'claims_duplicatemsncancel_button'
      }
    }
  }) // TODO: Uncomment - jest can't handle this right now. It likely needs updated to support: satisfies GenericEventMap
})

export type ClaimsKeys = keyof ReturnType<typeof claimsEventGenerator>

export default claimsEventGenerator
